<template>
  <div id="serviceAgreement" v-totop>
    <div class="container">
      <div class="list">
        <!-- <div>
          <div class="title"> {{protocol.protocolName}}</div>          
        </div> -->
         <div>
          <div class="text-html item" v-html="protocol.protocolMessages"></div>
        </div>
          <div class="signature item">
            <label class="">甲方代表签名</label>
            <div class="common-block">
             	<img :src="signature.code" style="height:130px;"/>
            </div>
          </div>
          <div class="signature-date item">
            <div class="text">签名日期</div>
            <div class="common-block">
             	{{signature.createDate}}
            </div>
          </div>
          <div class="seal item">
            <div class="time">
            <div class="text">盖章时间</div>
            <div class="common-block">
             	{{signature.createDate}}
            </div>
            </div>
            <div class="text seal-label ">乙方盖章</div>
            <img :src="webInfo.configImgs.pic18" alt="印章" />
          </div>
      </div>
    </div>
  </div>
</template>

<script>
import { fomateDate } from "@/util/util.js";
import axios from "axios";
// import api from "./api";

export default {
  name: "agreement",
  components: {
  },
  data() {
    return {
      content: "",
      type:1,
      title:'用户协议',
      signature:'',
      protocol:'',
      id:'',
    };
  },
  computed: {
    webInfo() {
      return this.$store.state.webInfo;
    },
  },
  methods: {
    fomateDate,
    // 获取协议
    getAgreement(){
    axios
        .get(`/order/signatureView.jhtml`, {
          params: {
            id: this.id,
          },
        })
        .then((res) => {
          if (res.data.success) {
            this.protocol = res.data.returnValue.protocol;
            this.signature = res.data.returnValue.signature;
            if(this.signature && this.signature.createDate){
              this.signature.createDate = fomateDate(this.signature.createDate);
            }
          } else {
            this.$vux.toast.text("系统繁忙，请稍后再试~", "middle");
          }
        });
    }
  },
  created(){
        if(this.$route.query.type){
          this.type=this.$route.query.type
        }
        if(this.$route.query.signatureId){
          this.id=this.$route.query.signatureId
        }
    this.getAgreement();
  },
  mounted() {
  },
};
</script>

<style scoped>

#serviceAgreement {
   display: block;
   position: absolute;
  height: 100%;
  width: 100%;
  top: 0;
  left: 0;
  padding-top: 15px;
   overflow: auto;
  -webkit-overflow-scrolling: touch;
}
 #serviceAgreement  .container {
    position: absolute;
    height: 100%;
    width: 100%;
    background: #ffffff;
 }
 #serviceAgreement  .container   .list {
      margin-top: 6px;
      padding: 30px;
      box-sizing: border-box;
    }
</style>
<style>
img {
  max-width: 100% !important;
}
.seal{
		position:relative;
	}
	.seal img{
		z-index:100;
		position: absolute;
	  z-index: 100;
	  top: 10px;
	  left: 25px;
    width: 140px;
    height: 140px;
	}
	.seal .time{
		position: absolute;
	    top: 40px;
      padding-bottom: 30px;
	}
	.seal{
		height:60px;
    /* text-align: left; */
	}
  .text-html{
    /* text-align: left; */
  }
  .title{
    font-size: 20px;
    font-weight: 700;
  }
  /* .signature{
    text-align: left;
  }
  .signature-date{
    text-align: left;
  } */
  .item{
    text-align: left;
    padding-bottom: 10px;
  }
  .item .common-block{
    padding-top: 5px;
  }
</style>


// WEBPACK FOOTER //
// src/components/userview/serviceAgreement.vue